"use strict";

exports.__esModule = true;

var tslib_1 = require("tslib");

var Article_1 = tslib_1.__importDefault(require("@sportnet/ui/lib/Article"));

var MediaManagerImage_1 = require("@sportnet/ui/lib/MediaManagerImage");

var prop_types_1 = tslib_1.__importDefault(require("prop-types"));

var react_1 = tslib_1.__importDefault(require("react"));

var styled_components_1 = tslib_1.__importDefault(require("styled-components"));

var propTypes_1 = require("../../propTypes");

var utilities_1 = require("../../utilities");

var linkClass = 'articlelist-tile';
var Wrapper = styled_components_1["default"]('section')(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(233px, 1fr));\n  grid-gap: ", "px;\n"], ["\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(233px, 1fr));\n  grid-gap: ", "px;\n"])), function (_a) {
  var theme = _a.theme;
  return theme.grid.gutterWidth;
});

var Tiles = function (_a) {
  var renderLink = _a.renderLink,
      articles = _a.articles,
      className = _a.className;
  return react_1["default"].createElement(Wrapper, {
    className: className
  }, articles.map(function (article) {
    return renderLink({
      type: utilities_1.WIDGET_LINK_TYPE.ARTICLE_DETAIL,
      payload: article,
      linkProps: {
        key: article._id,
        className: linkClass,
        children: react_1["default"].createElement(Article_1["default"], {
          title: article.name,
          subtitle: utilities_1.getArticleMeta(article),
          imgSrc: MediaManagerImage_1.getMediaManagerUrl(article.picture, 277, 208, 'media')
        })
      }
    });
  }));
};

Tiles.propTypes = {
  className: prop_types_1["default"].string,
  articles: prop_types_1["default"].arrayOf(propTypes_1.ArticlePropType).isRequired,
  renderLink: prop_types_1["default"].func.isRequired
};
Tiles.defaultProps = {
  className: null
};
exports["default"] = Tiles;
var templateObject_1;